import React from "react";
import "./Pages.css";

const DeliveryPolicy: React.FC = () => {
  return (
    <div className="page-container">
      <h1>Delivery Policy</h1>
      <p>
        The Destination Dreams Travel provides travel services (flight tickets,
        hotel reservations, holiday packages, car hire and travel insurance).
        These are <strong>intangible services delivered electronically</strong> —
        there is no physical shipment of goods.
      </p>

      <h2>How you receive your booking</h2>
      <ul>
        <li>
          Once your payment is successfully confirmed, your booking confirmation,
          e-ticket and/or voucher is sent to the email address you provided at the
          time of booking.
        </li>
        <li>
          Confirmations and e-documents are normally delivered <strong>within 24
          hours</strong> of a confirmed payment. During peak periods, or where a
          booking requires supplier (airline/hotel) confirmation, it may take up to
          <strong> 48–72 hours</strong>.
        </li>
        <li>
          A copy may also be shared via WhatsApp on request, and our team is
          available to re-send documents at any time.
        </li>
      </ul>

      <h2>Didn't receive your documents?</h2>
      <p>
        Please first check your spam/junk folder. If you have not received your
        confirmation within the timeframe above, contact us and we will resend it:
      </p>
      <ul>
        <li>Phone: +968 95987986</li>
        <li>Email: team@dreamstriphub.com</li>
        <li>Location: Amirat, Muscat, Oman</li>
      </ul>
    </div>
  );
};

export default DeliveryPolicy;
